import React, { FC } from "react";
import styled from "styled-components";
import contentfulComponentLoop from "../lib/contentfulComponentLoop";
import { Entry } from "contentful";

interface GridProps extends Entry {
  id: string,
  fields: {
    desktopColumnCount: number;
    mobileColumnCount?: number;
    tabletColumnCount?: number;
    components: any;
  },
  parentProps: {
    // These can be passed down from Section to allow mobile overflow.
    allowMobileOverflow: boolean;
    maxWidth?: number;
    theme: string;
  }
}

interface ContainerProps {
  $allowMobileOverflow: boolean;
  $desktopColumnCount: number;
  $mobileColumnCount?: number;
  $tabletColumnCount?: number;
  $overflowWidth?: number;
}

const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 0 -8px;

  ${({ $mobileColumnCount }) => $mobileColumnCount == 1 && `
    @media (max-width: 768px) {
      flex-direction: column;
      justify-content: flex-start;
    }
  `}

  ${({ $desktopColumnCount }) => $desktopColumnCount == 1 && `
    @media (min-width: 768px) {
      flex-direction: column;
      justify-content: flex-start;
    }
  `}

  ${({ $mobileColumnCount, $desktopColumnCount }) => $mobileColumnCount && $desktopColumnCount && `
    > div, > a {
      padding: 0 8px;
      margin-bottom: 30px;
      width: calc(100% / ${$mobileColumnCount});

      @media (min-width: 1024px) {
        width: calc(100% / ${$desktopColumnCount});
      }
    }
  `}

  ${({ $tabletColumnCount }) => $tabletColumnCount != undefined && `
    > div, > a {
      @media (min-width: 768px) and (max-width: 1023px) {
        width: calc(100% / ${$tabletColumnCount});
      }
     }
  `}

  ${({ $allowMobileOverflow, $overflowWidth }) => $allowMobileOverflow && $overflowWidth && `
    @media (max-width: 768px) {
      width: ${$overflowWidth}px;
    }
  `}
`;

const Grid: FC<GridProps> = ({ id, fields, parentProps }) => {
  const { desktopColumnCount, mobileColumnCount, tabletColumnCount, components } = fields;
  const { allowMobileOverflow, maxWidth, theme } = parentProps;

  return (
    <Container 
      data-component-id={id}
      $allowMobileOverflow={allowMobileOverflow}
      $desktopColumnCount={desktopColumnCount} 
      $mobileColumnCount={mobileColumnCount}
      $tabletColumnCount={tabletColumnCount}
      $overflowWidth={maxWidth}
    >
      {contentfulComponentLoop(components, { theme })}
    </Container>
  );
};

export default Grid;